<template>
  <div>
    <v-list>
      <v-list-item @click="handleRecived" v-if="props.item.status === 1"> 
        <v-list-item-icon class="ml-3">
          <img src="./assets/1.svg" style="width: 20px" alt="recived" v-if="!$store.getters.isDark" />
          <img src="./assets/1White.svg" style="width: 20px" alt="recived" v-if="$store.getters.isDark" />
        </v-list-item-icon>
        <v-list-item-title>{{ recived }}</v-list-item-title> 
      </v-list-item>

      <v-list-item @click="switchUser" v-if="props.item.status === 1">
        <v-list-item-icon class="ml-3">
          <img src="./assets/2.svg" style="width: 20px" alt="switch" v-if="!$store.getters.isDark" />
          <img src="./assets/2White.svg" style="width: 20px" alt="switch" v-if="$store.getters.isDark" />
        </v-list-item-icon>
        <v-list-item-title> تسجيل الدخول بهذا الحساب</v-list-item-title>
      </v-list-item>

      <v-list-item @click="handleEdit">
        <v-list-item-icon class="ml-3">
          <img src="./assets/3White.svg" style="width: 20px" alt="edit" v-if="$store.getters.isDark" />
          <img src="./assets/3.svg" style="width: 20px" alt="edit" v-else />
        </v-list-item-icon>
        <v-list-item-title>تعديل</v-list-item-title>
      </v-list-item>

      <v-list-item @click="restoreUser" v-if="props.item.status === 0">
        <v-list-item-icon class="ml-3">
          <img src="./assets/restore.svg" style="width: 20px" alt="restore" v-if="!$store.getters.isDark" />
          <img src="./assets/restoreWhite.svg" style="width: 20px" alt="restore" v-if="$store.getters.isDark" />
        </v-list-item-icon>
        <v-list-item-title>استرجاع</v-list-item-title>
      </v-list-item>

      <v-list-item @click="handleArchived">
        <v-list-item-icon class="ml-3">
          <img src="./assets/4.svg" style="width: 20px" alt="archive" v-if="!$store.getters.isDark" />
          <img src="./assets/4White.svg" style="width: 20px" alt="archive" v-if="$store.getters.isDark" />
        </v-list-item-icon>
        <v-list-item-title> ارشفه</v-list-item-title>
      </v-list-item>

      <v-list-item @click="handleShowProfile">
        <v-list-item-icon class="ml-3">
          <img src="./assets/5.svg" style="width: 20px" alt="profile" v-if="!$store.getters.isDark" />
          <img src="./assets/5White.svg" style="width: 20px" alt="profile" v-if="$store.getters.isDark" />
        </v-list-item-icon>
        <v-list-item-title>عرض ملف الموظف</v-list-item-title>
      </v-list-item>

      <v-list-item @click="handleShowNotification" v-if="props.item.status === 1">
        <v-list-item-icon class="ml-3">
          <img src="./assets/6.svg" style="width: 20px" alt="notif" v-if="!$store.getters.isDark" />
          <img src="./assets/6White.svg" style="width: 20px" alt="notif" v-if="$store.getters.isDark" />
        </v-list-item-icon>
        <v-list-item-title>تنبيهات البريد الالكتروني</v-list-item-title>
      </v-list-item>

      <v-list-item @click="openChats" v-if="props.item.status === 1">
        <v-list-item-icon class="ml-3">
          <img src="./assets/7.svg" style="width: 20px" alt="chat" v-if="!$store.getters.isDark" />
          <img src="./assets/7White.svg" style="width: 20px" alt="chat" v-if="$store.getters.isDark" />
        </v-list-item-icon>
        <v-list-item-title>محادثات العملاء</v-list-item-title>
      </v-list-item>
    </v-list>
  </div>
</template>

<script setup>
import { axiosInstance } from "@/axios/config";
import { defineProps, ref, defineEmits } from "vue";
import router from "@/routes";

const props = defineProps(["item"]);
const emit = defineEmits(["recived", "switchUser", "archived"]);

// const recived = ref(" عدم السماح بإستلام الطلبات");
const recived = ref(
  props.item.allow_recived === "نشط"
    ? " عدم السماح بإستلام الطلبات"
    : " السماح بإستلام الطلبات"
);

const handleRecived = () => {
  axiosInstance
    .post(`/employee/admin/allowReceivedRequest`, { user_id: props.item.id })
    .then((res) => {
      recived.value =
        props.item.allow_recived !== "نشط"
          ? " عدم السماح بإستلام الطلبات"
          : `السماح بإستلام الطلبات`;
      emit("recived");
    });
};

const switchUser = () => {
  emit("switchUser", props.item.id);
};

const handleShowNotification = () => {
  router.push({
    name: "show-notification",
    params: { id: props.item.id },
  });
};

const handleEdit = () => {
  router.push({
    name: "edit-user",
    params: { id: props.item.id },
  });
};

const restoreUser = () => {
  axiosInstance
    .post(`/v2/employee/restore-archived-users`, { users_ids: [props.item.id] })
    .then((res) => {
      emit("recived");
    });
};

const handleArchived = () => {
  emit("archived", props.item.id);
};

const handleShowProfile = () => {
  router.push({
    name: "personal-info",
    params: { id: props.item.id },
  });
};

const openChats = () => {
  router.push({
    name: "show-chats",
    params: { id: props.item.id },
  });
};
</script>
